import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface Message {
  message: string
}

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent {

  message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Message
  ) { 

    this.message = this.data.message;

  }

}
